module.exports = __webpack_public_path__ + "img/crew_adv_08.444966b4.png";